module.exports = __webpack_public_path__ + "assets/b132c7c9d0a4f1b3a2c4d5caa7eaba83.png";